// @flow
import { type Sentry } from "./types";

let sentry;

if (window.Sentry) {
  sentry = window.Sentry;
} else {
  sentry = ({
    onLoad: () => undefined,
    init: () => undefined,
    configureScope: () => undefined,
    captureException: (error) => console.log(error),
    captureMessage: (message) => console.log(message),
    setUser: () => undefined,
  }: any);
}

export default (sentry: Sentry);
